"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosHttpClient = exports.AxiosHttpError = void 0;
var promise_1 = require("../utils/promise");
var progress_1 = require("../common/progress");
var axios_1 = require("axios");
var errors_1 = require("../common/errors");
var object_1 = require("../common/object");
var stopwatch_1 = require("../common/stopwatch");
var cancel_1 = require("../common/cancel");
var win_1 = require("../win");
var xdomainrequest_1 = require("./xdomainrequest");
var composed_1 = require("./authentication/composed");
var objects_1 = require("../utils/objects");
var string_1 = require("../utils/string");
// axios tries to send CORS-requests using XDomainRequest in IE8 and IE9.
// XDomainRequest by design does not attach any cookies, which was causing KEF-687
if ((0, win_1.win)().XDomainRequest)
    (0, win_1.win)().XDomainRequest = xdomainrequest_1.default;
var importantHeaders = [
    "x-kontur-trace-id",
    "traceid",
    "content-range",
    "content-length",
    "location",
];
var cacheRegex = /([?&])_=[^&]*/;
var rquery = /\?/;
var nonce = Date.now();
var AxiosHttpResponse = /** @class */ (function () {
    function AxiosHttpResponse(axiosResponse) {
        if (!axiosResponse)
            return;
        this.status = axiosResponse.status;
        this.statusText = axiosResponse.statusText;
        this.headers = axiosResponse.headers;
        var contentTypeHeader = axiosResponse.headers["content-type"];
        if (contentTypeHeader &&
            contentTypeHeader.indexOf("text") === 0 &&
            axiosResponse["request"].response &&
            axiosResponse.config.responseType !== "json") {
            this.data = axiosResponse["request"].response;
        }
        else {
            this.data = axiosResponse.data;
        }
    }
    AxiosHttpResponse.prototype.isDisposed = function () {
        return this.disposed;
    };
    AxiosHttpResponse.prototype.dispose = function () {
        this.data = null;
        this.disposed = true;
    };
    return AxiosHttpResponse;
}());
var AxiosHttpError = /** @class */ (function (_super) {
    __extends(AxiosHttpError, _super);
    function AxiosHttpError(httpRequest, axiosError) {
        var _this = this;
        //todo more precise details
        var statusInfo = "Http request was unsuccessful. " +
            (axiosError.response
                ? "Status code: " +
                    axiosError.response.status +
                    " " +
                    axiosError.response.statusText
                : axiosError.toString());
        var responseInfo = statusInfo;
        //костыль для фт KE-7496
        if (axiosError.response &&
            axiosError.response.data &&
            axiosError.response.data.length > 0 &&
            axiosError.response.data.length < 500) {
            responseInfo = axiosError.response.data;
        }
        var userMessage = null;
        if (axiosError.response &&
            axiosError.response.data &&
            axiosError.response.data.userMessage) {
            userMessage = axiosError.response.data.userMessage;
        }
        _this = _super.call(this, responseInfo, userMessage, errors_1.ErrorCodes.HttpError) || this;
        _this.request = httpRequest;
        _this.status = axiosError.code;
        _this.response = axiosError.response
            ? new AxiosHttpResponse(axiosError.response)
            : null;
        return _this;
    }
    return AxiosHttpError;
}(errors_1.CommonError));
exports.AxiosHttpError = AxiosHttpError;
var requestId = 0;
var AxiosHttpClient = /** @class */ (function (_super) {
    __extends(AxiosHttpClient, _super);
    function AxiosHttpClient(authenticationProviders, config, customLog) {
        if (authenticationProviders === void 0) { authenticationProviders = []; }
        var _this = _super.call(this, "AxiosHttpClient") || this;
        if (customLog)
            _this.log = customLog;
        _this.client = config ? axios_1.default.create(config) : axios_1.default;
        _this.authenticationProvider = Array.isArray(authenticationProviders)
            ? new composed_1.ComposedHttpAuthenticationProvider(authenticationProviders)
            : authenticationProviders;
        return _this;
    }
    AxiosHttpClient.prototype.send = function (request, token, progress) {
        var _this = this;
        token && token.throwIfCancelled();
        var cancelTokenSource = axios_1.default.CancelToken.source();
        this.authenticationProvider &&
            this.authenticationProvider.setAuthenticationData(request);
        var axiosRequest = buildAxiosRequest(request, cancelTokenSource, progress);
        requestId++;
        var stopwatch = stopwatch_1.Stopwatch.startNew();
        var url = axiosRequest.url;
        this.log.debug("start", { requestId: requestId, url: url });
        return (0, promise_1.newPromise)(function (resolve, reject) {
            var cancelRegistration = token
                ? token.register(function () {
                    cancelTokenSource.cancel();
                    reject(new cancel_1.CancellationError());
                })
                : null;
            _this.client(axiosRequest)
                .then(function (response) {
                progress && progress.complete();
                var elapsed = stopwatch.elapsedMilliseconds();
                var headers = extractImportantHeaders(response);
                _this.log.debug("success", __assign({ requestId: requestId, url: url, response: response, elapsed: elapsed }, headers));
                resolve(new AxiosHttpResponse(response));
            }, function (error) {
                var elapsed = stopwatch.elapsedMilliseconds();
                var headers = extractImportantHeaders(error.response);
                if (axios_1.default.isCancel(error)) {
                    _this.log.debug("request was cancelled", {
                        requestId: requestId,
                        url: url,
                        elapsed: elapsed,
                    });
                    throw new cancel_1.CancellationError();
                }
                var httpError = new AxiosHttpError(request, error);
                var statusCode = error.response ? error.response.status : 0;
                var strippedUrl = (0, string_1.stripUrl)(url);
                var errorCode = "http fail ".concat(statusCode, " at ").concat(strippedUrl);
                var payload = __assign({ requestId: requestId, elapsed: elapsed, url: url, fingerprint: [strippedUrl, "".concat(statusCode)[0] + "xx"] }, headers);
                var commonError = new errors_1.CommonError(errorCode, null, errorCode, payload, httpError);
                if (statusCode === 409) {
                    _this.log.info("warn", { commonError: commonError, payload: payload });
                }
                else if ((statusCode >= 400 && statusCode < 500) ||
                    statusCode === 0) {
                    _this.log.warn(errorCode, { commonError: commonError, payload: payload });
                }
                else {
                    _this.log.error(errorCode, commonError, payload);
                }
                reject(httpError);
            })
                .then(function () { return cancelRegistration && cancelRegistration.dispose(); });
        });
    };
    return AxiosHttpClient;
}(object_1.BaseObject));
exports.AxiosHttpClient = AxiosHttpClient;
function extractImportantHeaders(response) {
    var result = {};
    if (!response || !response.headers)
        return result;
    var headersLowered = (0, objects_1.lowerObjectKeys)(response.headers);
    importantHeaders.forEach(function (header) {
        if (header in headersLowered)
            result[header] = headersLowered[header];
    });
    return result;
}
function buildAxiosRequest(request, cancelTokenSource, progress) {
    progress = progress ? progress : new progress_1.Progress();
    var axiosRequest = {
        url: request.url,
        method: request.method,
        data: request.data,
        baseURL: request.baseURL,
        headers: request.headers,
        params: request.params,
        timeout: request.timeout,
        withCredentials: request.withCredentials,
        cancelToken: cancelTokenSource.token,
        responseType: request.responseType,
    };
    // xhr.js in axios uses addEventListener to handle onDownloadProgress, which result in crash in ie8.
    if (document.addEventListener) {
        axiosRequest.onDownloadProgress = function (progressEvent) {
            if (!progressEvent.lengthComputable)
                return;
            progress.set((progressEvent.loaded * 100) / progressEvent.total);
        };
    }
    if (!axiosRequest.timeout)
        axiosRequest.timeout = 600000; //10 min
    if (request.cache === false) {
        axiosRequest.url = cacheRegex.test(axiosRequest.url)
            ? axiosRequest.url.replace(cacheRegex, "$1_=" + nonce++)
            : axiosRequest.url +
                (rquery.test(axiosRequest.url) ? "&" : "?") +
                "_=" +
                nonce++;
    }
    return axiosRequest;
}
